<template>
  <div class="input-textfield">
    <label :for="inputId">{{ label }}</label>
    <input
      type="text"
      :id="inputId"
      :value="value"
      @input="updateModel($event.target.value)"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :maxlength="maxlength"
    />
  </div>
</template>

<script>
export default {
  props: {
    // Required props
    value: {
      // value for v-model to bind to
      type: String, 
      default: "",
      required: true,
    },

    // Optional props
    label: String, // label text
    inputId: String, // id to input and label, cause id on component applies it to div
    placeholder: String, // placeholder text
    isDisabled: [Boolean, String], // toggle for disabled or not
    maxlength: [Number, String], // max length of value
  },
  methods: {
    updateModel(value) {
      // Imitate what v-model does and emit that to parent component v-model
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
